import _orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

export const orderBy = <T, C>(
  items: C[],
  fn: (item: C) => T,
  direction: 'asc' | 'desc' = 'asc'
) => {
  return _orderBy(items, fn, direction);
};

export const uniqueBy = <T, C>(items: C[], fn: (item: C) => T) => {
  return uniqBy(items, fn);
};

export function onlyTruthy<V>(value?: V | null): value is V {
  return !!value;
}
